import { motion, useInView } from 'framer-motion'
import { useRef } from 'react'
import checkIcon from '../../../../Imgs/Home/check.svg'
import handIcon from '../../../../Imgs/Home/hand.svg'

function Offers() {
  const ref = useRef(null)
  const isInView = useInView(ref, { once: true, amount: 0.3 })

  return (
    <>
      <div className="bg-[#FFF] relative">
        <div className="mx-auto px-6 lg:px-12 max-w-7xl">
          <div ref={ref} className="flex flex-col justify-between lg:flex-row">
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              animate={isInView ? { opacity: 1, x: 0 } : {}}
              transition={{ duration: 0.6 }}
              className="flex flex-col w-[90%] lg:w-[50%] mt-10 lg:mt-20"
            >
              <h1 className="text-left text-xl text-[#FF484A] md:text-4xl mx-[10px] font-bold">
                ¿Qué servicios ofrece?
              </h1>
              <p className="text-sm font-bold md:text-xl mt-5 mx-[10px]">
                Pide y Pasa ofrece una solución tecnológica que permite a los
                restaurantes:
              </p>
              <ul className="mt-5 space-y-3 mx-[10px] list-none pl-0 !flex-col !justify-start">
                <motion.li
                  initial={{ opacity: 0, x: -30 }}
                  animate={isInView ? { opacity: 1, x: 0 } : {}}
                  transition={{ duration: 0.5, delay: 0.1 }}
                  className="flex items-start gap-3"
                >
                  <img
                    src={checkIcon}
                    alt="check"
                    className="w-6 h-6 flex-shrink-0 mt-1"
                  />
                  <span className="text-sm md:text-xl">
                    Gestionar pedidos en línea de forma ágil y organizada.
                  </span>
                </motion.li>
                <motion.li
                  initial={{ opacity: 0, x: -30 }}
                  animate={isInView ? { opacity: 1, x: 0 } : {}}
                  transition={{ duration: 0.5, delay: 0.2 }}
                  className="flex items-start gap-3"
                >
                  <img
                    src={checkIcon}
                    alt="check"
                    className="w-6 h-6 flex-shrink-0 mt-1"
                  />
                  <span className="text-sm md:text-xl">
                    Programar pedidos para que estén listos exactamente en el
                    momento en que el cliente decida recogerlos.
                  </span>
                </motion.li>
                <motion.li
                  initial={{ opacity: 0, x: -30 }}
                  animate={isInView ? { opacity: 1, x: 0 } : {}}
                  transition={{ duration: 0.5, delay: 0.3 }}
                  className="flex items-start gap-3"
                >
                  <img
                    src={checkIcon}
                    alt="check"
                    className="w-6 h-6 flex-shrink-0 mt-1"
                  />
                  <span className="text-sm md:text-xl">
                    Reducir tiempos de espera y filas en el punto de venta.
                  </span>
                </motion.li>
                <motion.li
                  initial={{ opacity: 0, x: -30 }}
                  animate={isInView ? { opacity: 1, x: 0 } : {}}
                  transition={{ duration: 0.5, delay: 0.4 }}
                  className="flex items-start gap-3"
                >
                  <img
                    src={checkIcon}
                    alt="check"
                    className="w-6 h-6 flex-shrink-0 mt-1"
                  />
                  <span className="text-sm md:text-xl">
                    Optimizar los procesos internos de cocina y despacho.
                  </span>
                </motion.li>
                <motion.li
                  initial={{ opacity: 0, x: -30 }}
                  animate={isInView ? { opacity: 1, x: 0 } : {}}
                  transition={{ duration: 0.5, delay: 0.5 }}
                  className="flex items-start gap-3"
                >
                  <img
                    src={checkIcon}
                    alt="check"
                    className="w-6 h-6 flex-shrink-0 mt-1"
                  />
                  <span className="text-sm md:text-xl">
                    Mejorar la experiencia del usuario final mediante un sistema
                    eficiente, práctico y enfocado en la puntualidad.
                  </span>
                </motion.li>
              </ul>
            </motion.div>
          </div>
        </div>

        <motion.img
          initial={{ opacity: 0, scale: 0.9 }}
          animate={isInView ? { opacity: 1, scale: 1 } : {}}
          transition={{ duration: 0.8, delay: 0.3 }}
          src={handIcon}
          alt="Hand"
          className="hidden lg:block absolute right-0 top-0 h-96 object-contain"
        />
      </div>
    </>
  )
}

export default Offers
